import { Table } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import React from "react";
import { Link } from "react-router-dom";
import { HasPermission } from "@/helpers/permission";

export default function TransactionsTable({ dataList }) {
  const { data, loading } = dataList;

  const renderStatus = (item) => {
    if (item === "I")
      return (
        <b style={{ fontSize: 15 }}>
          <IntlMessages id="page.overview.transactions.status.initialized" />
        </b>
      );
    if (item === "C")
      return (
        <b style={{ fontSize: 15 }}>
          <IntlMessages id="page.overview.transactions.status.completed" />
        </b>
      );
    if (item === "P")
      return (
        <b style={{ fontSize: 15 }}>
          <IntlMessages id="page.overview.transactions.status.processing" />
        </b>
      );
    if (item === "A")
      return (
        <b style={{ fontSize: 15 }}>
          <IntlMessages id="page.overview.transactions.status.abandoned" />
        </b>
      );
  };
  const renderRisk = (item) => {
    if (item === null)
      return (
        <p className="font-medium">
          <b>N/A</b>
        </p>
      );
    if (item === "H")
      return (
        <p className={"font-medium text-high"}>
          <b>High</b>
        </p>
      );
    if (item === "L")
      return (
        <p className="font-medium text-low">
          <b>Low</b>
        </p>
      );
    if (item === "U" || item === null)
      return (
        <p className="font-medium text-unknown">
          <b>Unknown</b>
        </p>
      );
  };

  const renderDate = (date) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return new Date(date).toLocaleDateString("pt-BR", options);
  };

  const renderDetailsButton = (id) => {
    return (
      <Link style={{ color: "#00ABAB" }} to={`/transactions/${id}`}>
        <IntlMessages id="page.transactions.table.details" />
      </Link>
    );
  };

  const fullColumns = [
    {
      title: <IntlMessages id="page.overview.transactions.filters.date" />,
      dataIndex: "updated",
      render: (item) => renderDate(item),
      width: 200,
    },
    {
      title: <IntlMessages id="page.overview.transactions.filters.id" />,
      dataIndex: "transaction_id",
      key: "transaction_id",
      width: 300,
    },
    {
      title: <IntlMessages id="page.overview.transactions.filters.risk" />,
      dataIndex: "risk",
      key: "risk",
      render: (item) => renderRisk(item),
      width: 100,
    },
    {
      title: "Match Score",
      dataIndex: ["scores", "face_match", "score"],
      key: "face_match",
      render: (item) => (item ? item : "N/A"),
      width: 130,
    },
    {
      title: "Liveness Score",
      dataIndex: ["scores", "liveness", "score"],
      key: "liveness",
      render: (item) => (item ? item : "N/A"),
      width: 130,
    },
    {
      title: <IntlMessages id="page.overview.transactions.filters.status" />,
      dataIndex: "status",
      render: (item) => renderStatus(item),
      width: 150,
    },
    {
      title: <IntlMessages id="page.overview.transactions.filters.details" />,
      fixed: "right",
      width: 100,
      render: (item) => {
        if (HasPermission("view_transaction")) {
          return renderDetailsButton(item.transaction_id);
        }
      },
    },
  ];

  return (
    <Table
      dataSource={data}
      scroll={{ x: 870 }}
      loading={loading}
      pagination={{ position: ["none", "none"] }}
      columns={fullColumns}
    />
  );
}
